import React, { useEffect, useState, useCallback } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { UI_CONSTANTS } from "../../utils/constants";

const normalizeUrl = (value) => {
  if (!value) return "";
  const trimmed = value.trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

function BookingTicket() {
  const [ticketUrl, setTicketUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  const fetchBookingDetails = useCallback(async () => {
    setFetching(true);
    try {
      const response = await handleApiCall("get", endpoints.getBookTicket);
      if (response?.data?.code === 200 || response?.data?.code === "200" || response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        const payload = response?.data?.data || response?.data;
        const existingUrl = payload?.ticket_url || payload?.url || "";
        setTicketUrl(existingUrl);
      } else if (response?.error) {
        console.error("Error fetching booking ticket:", response?.message);
      }
    } catch (error) {
      console.error("Error fetching booking ticket:", error);
      toast.error("Failed to fetch booking ticket details");
    } finally {
      setFetching(false);
    }
  }, []);

  useEffect(() => {
    fetchBookingDetails();
  }, [fetchBookingDetails]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!ticketUrl.trim()) {
      toast.error("Please enter booking ticket URL");
      return;
    }

    const normalizedUrl = normalizeUrl(ticketUrl);
    try {
      new URL(normalizedUrl);
    } catch (error) {
      toast.error("Please enter a valid URL");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        ticket_url: normalizedUrl,
      };
      const response = await handleApiCall("put", endpoints.updateBookTicket, payload);
      if (response?.data?.code === 200 || response?.data?.code === "200" || response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        toast.success("Booking ticket updated successfully!");
        setTicketUrl(normalizedUrl);
      } else if (response?.error) {
        console.error("Error updating booking ticket:", response?.message);
      }
    } catch (error) {
      console.error("Error updating booking ticket:", error);
      toast.error("Failed to update booking ticket");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <div className="container-scroller">
        <Header />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
              <div className="spinner-border" role="status">
                <span className="sr-only">{UI_CONSTANTS.BUTTON_LABELS.LOADING}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Booking Ticket</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <form onSubmit={handleSubmit}>
                <div className="card-heading d-flex align-items-center mb-3 pb-2">
                  <div className="d-flex align-items-center justify-content-start col-md-12 px-0">
                    <Button type="submit" className="rounded-lg" disabled={loading}>
                      {loading ? UI_CONSTANTS.BUTTON_LABELS.UPDATING : UI_CONSTANTS.BUTTON_LABELS.UPDATE}
                    </Button>
                  </div>
                </div>
                <div className="row mx-n2">
                  <div className="form-group col-md-12 px-2">
                    <label className="text-white mb-2">Booking Ticket URL</label>
                    <input
                      type="url"
                      className="form-control default"
                      placeholder="Enter booking ticket URL (e.g., https://example.com)"
                      value={ticketUrl}
                      onChange={(e) => setTicketUrl(e.target.value)}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookingTicket;

